import {useEffect, useRef} from 'react'
import {isServer} from '@salesforce/retail-react-app/app/utils/utils'

const usePdpBannerRecovery = ({
    productId,
    pid,
    isProductQueryEnabled,
    isProductFetched,
    isProductFetching,
    hasBannerInfo,
    basketId,
    isBasketLoading,
    shopperContext,
    createBasket,
    refetchBasket,
    refetchProduct,
    pathname,
    search,
}) => {
    const hasRetriedBannerProductRef = useRef(null)
    const hasCreatedBannerBasketRef = useRef(null)

    useEffect(() => {
        hasRetriedBannerProductRef.current = null
        hasCreatedBannerBasketRef.current = null
    }, [productId, pathname, search])

    useEffect(() => {
        const currentProductId = pid || productId

        if (
            isServer ||
            !currentProductId ||
            !isProductQueryEnabled ||
            !isProductFetched ||
            isProductFetching ||
            hasBannerInfo ||
            basketId ||
            isBasketLoading ||
            hasCreatedBannerBasketRef.current === currentProductId ||
            hasRetriedBannerProductRef.current === currentProductId
        ) {
            return
        }

        hasCreatedBannerBasketRef.current = currentProductId

        createBasket
            .mutateAsync({body: {}})
            .then(async () => {
                await refetchBasket()
                await refetchProduct()
                // Mark retry done regardless of whether banner ended up present —
                // prevents repeated attempts on products that have no banner configured.
                hasRetriedBannerProductRef.current = currentProductId
            })
            .catch(() => {
                hasCreatedBannerBasketRef.current = null
            })
    }, [
        basketId,
        createBasket,
        hasBannerInfo,
        isBasketLoading,
        isProductFetched,
        isProductFetching,
        isProductQueryEnabled,
        pid,
        productId,
        refetchBasket,
        refetchProduct,
    ])

    useEffect(() => {
        const currentProductId = pid || productId

        if (
            isServer ||
            !currentProductId ||
            !isProductQueryEnabled ||
            !isProductFetched ||
            isProductFetching ||
            !basketId ||
            !shopperContext ||
            hasBannerInfo ||
            hasRetriedBannerProductRef.current === currentProductId
        ) {
            return
        }

        hasRetriedBannerProductRef.current = currentProductId
        refetchProduct()
    }, [
        basketId,
        hasBannerInfo,
        isProductFetched,
        isProductFetching,
        isProductQueryEnabled,
        pid,
        productId,
        refetchProduct,
        shopperContext,
    ])
}

export default usePdpBannerRecovery
